import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ParticipanteConglomerado } from "src/app/model/participante.conglomerado.model"
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Cotista } from "src/app/model/cotista.model";
import { DatePipe } from "@angular/common";
import { SelectCotistaComponent } from "../../select-cotista/select-cotista.component";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO, ROLE_AGENTE_CONSULTA } from "src/app/constantes/permissao.constants";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ExportService } from "../../export.service";
import { ConglomeradoService } from "../../conglomerado.service";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { Router, NavigationEnd } from "@angular/router";
import { AgenteFinanceiroService } from "src/app/shared/services/agente-financeiro.service";

export interface ConglomeradoDto {
    id?: number;
    cotista: string;
    percentual: string;
    dataInicio: Date;
    dataFim: Date;
    codigo: string;
    situacao: string;
}

@Component({
    selector: 'app-conglomerado-pesquisa',
    templateUrl: 'conglomerado-pesquisa.component.html',
    standalone: false
})
export class ConglomeradoPesquisaComponent implements OnInit{
    atributosPaginacaoComponenteListagem: EntityPagedResult<ParticipanteConglomerado>;
    opcoesPaginacao: number[];
    podeCadastrarConglomerado: boolean = false;
    podeConsultarConglomerado: boolean = false;
    conglomerados: ParticipanteConglomerado[] = [];
    pesquisaForm: UntypedFormGroup;
    situacoes: any;
    msgSemResultado: boolean = false;
    dataHoraResultado: string;
    cotista: Cotista;
    codigo: number;
    cnpjUsuario: string;
    agentesFinanceiros: AgenteFinanceiro[] = [];
    agenteFinanceiroSelecionado: AgenteFinanceiro;

    @ViewChild(SelectCotistaComponent) selectCotistaComponent: SelectCotistaComponent;

    constructor(
        private formBuilder:UntypedFormBuilder,
        private bnLoadingService:BnLoadingService,
        private datePipe:DatePipe,
        private permissaoService: PermissaoService,
        private bnUsuarioService:BnUsuarioService,
        private exportService: ExportService,
        private conglomeradoService: ConglomeradoService,
        private el: ElementRef,
        private agenteFinanceiroServico: AgenteFinanceiroService,
        private router: Router,
    ){
    this.pesquisaForm = this.formBuilder.group({
        id: null,
        situacao: null,
        dataInicial: null,
        dataFinal: null,
        codigo: new FormControl('', [Validators.pattern(/^[CGL]{1,}[0-9]{3}$/i)]),
        agenteFinanceiro: null,
    });
    }

    ngOnInit(): void {
        this.situacoes = [
            {label: 'Todos', value: null},
            {label: 'Ativo', value: 'Ativo'},
            {label: 'Inativo', value: 'Inativo'},
        ]
        
        this.opcoesPaginacao = [10, 15, 20];
        
        this.atributosPaginacaoComponenteListagem = {
          page: 1,
          pageSize: this.opcoesPaginacao[0],
          pages: undefined,
          count: undefined,
          list: undefined
        };

        this.agenteFinanceiroServico.getAgentesFinanceiros()
        .subscribe((response => {
            this.agentesFinanceiros = response ? response.sort((a, b) => a?.sigla ? a.sigla.localeCompare(b.sigla) : 0) : null;
        }));

        this.permissaoService.getPermissoesUsuarioAutenticado()
        .subscribe((resp: any) => {
            this.podeCadastrarConglomerado = resp && resp[ROLE_GESTOR_ENVIO];
            this.podeConsultarConglomerado = resp && (resp[ROLE_GESTOR_ENVIO] || resp[ROLE_GESTOR_CONSULTA]);
            if (resp && resp[ROLE_AGENTE_CONSULTA]) {
                this.bnUsuarioService.usuario$.subscribe(usuario => {
                    if (usuario && usuario.cnpj) {
                        this.cnpjUsuario = usuario.cnpj;
                        this.construirFormulario(usuario.cnpj)
                    }
                });
            } else {
                this.construirFormulario();
            }
        });
        this.construirFormulario();
        this.mudouDeRota();
    }

    mudouDeRota(){
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.limpar();   
            }
        });
    }

    mudancaPagina(novaPagina: EntityPagedResult<ParticipanteConglomerado>) {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscar(true);
    }

    private construirFormulario(cnpj?: string) {
        const valoresPesquisaForm = JSON?.parse(sessionStorage.getItem('valoresPesquisaConglomeradoForm'));
        if (valoresPesquisaForm) {
            this.pesquisaForm.setValue({
                id: null,
                situacao: valoresPesquisaForm.situacao,
                dataInicial: valoresPesquisaForm.dataInicial,
                dataFinal: valoresPesquisaForm.dataFinal,
                codigo: valoresPesquisaForm.codigo,
                agenteFinanceiro: valoresPesquisaForm.agenteFinanceiro,
            });
        }
        this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
            sessionStorage.setItem('valoresPesquisaConglomeradoForm', JSON.stringify(novosValores));
        });
    }

    buscar(paginado: boolean){
        this.bnLoadingService.bloqueiaTela();
        const dadosPreenchidos = this.tratarInformacoesPreenchidas();
        dadosPreenchidos.pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
        dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;
        
        this.conglomeradoService.getConglomerados(dadosPreenchidos).subscribe((response => {
            this.conglomerados = response ? response.resultados : null;
            this.atributosPaginacaoComponenteListagem.count = response ?
                response.totalRegistrosSemPaginacao : 0;
            this.msgSemResultado = (this.atributosPaginacaoComponenteListagem.count === 0) || false;
        }));

        this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
        this.bnLoadingService.liberaTela();
    }

    tratarInformacoesPreenchidas(){
        let dadosPreenchidos:any = {};
        const form = this.pesquisaForm.value;
        
        if(form.dataInicial){
            dadosPreenchidos.dataInicial = this.datePipe.transform(form.dataInicial, 'yyyyMMdd');
        }
        if(form.dataFinal){
            dadosPreenchidos.dataFinal = this.datePipe.transform(form.dataFinal, 'yyyyMMdd');
        }
        if (form.situacao) {
            dadosPreenchidos.situacao = form.situacao;
        }
        if (form.codigo) {
            const codigoSemLetras = form.codigo.replace(/[a-zA-Z]/g, '');
            dadosPreenchidos.codigo = codigoSemLetras;
        }
        if (this.cnpjUsuario) {
            const agenteFinanceiro = this.agentesFinanceiros.find(agente => agente.cnpj === this.cnpjUsuario);
            dadosPreenchidos.agenteFinanceiro = agenteFinanceiro?.id;
            dadosPreenchidos.cnpjUsuario = this.cnpjUsuario;
        } else if (form.agenteFinanceiro) {
            dadosPreenchidos.agenteFinanceiro = form.agenteFinanceiro;
        }
        return dadosPreenchidos;
    }

    limpar() {
        this.atributosPaginacaoComponenteListagem.page = 1;
        this.conglomerados = [];
        this.msgSemResultado = false;
        if (!this.cnpjUsuario) {
            this.pesquisaForm.reset();
            this.cnpjUsuario = null;
        } else if (this.cnpjUsuario) {
            this.resetFormQuandoAFLogado();
        }
        setTimeout(() => {
            this.removeNgInvalidInput('dataInicial');
            this.removeNgInvalidInput('dataFinal');
        }, 100);
    }

    resetFormQuandoAFLogado() {
        this.pesquisaForm = this.formBuilder.group({
            id: null,
            situacao: null,
            dataInicial: null,
            dataFinal: null,
            codigo: null,
        });
    }

    removeNgInvalidInput(id: string){
        const inputElement = this.el.nativeElement.querySelector(`#${id}`);
        inputElement.classList.remove('ng-invalid');
    }

    exportarListaConglomerado() {
        this.bnLoadingService.bloqueiaTela();
        const dadosPreenchidos = this.tratarInformacoesPreenchidas();
        this.conglomeradoService.getConglomerados(dadosPreenchidos).subscribe((response) => {
            this.exportService.exportarListaConglomerado(response);
        })
        this.bnLoadingService.liberaTela();
    }

}